import { IComponentOptions, IController, ISCEService } from 'angular';
import './mail-body.component.scss';
import { MailboxService } from '../../services';
import { Mail } from '../../shared/mail';
import { ToastrService } from '../../../../core/services/toastr/toastr.service';

class MailBodyCtrl implements IController {
  static $inject = [
    'MailboxService',
    'ToastrService',
    '$sce'
  ];
  mail: Mail;
  mailId: string;
  loading: boolean;
  errorMessage: string;

  constructor( private mailboxService: MailboxService,
               private toastrService: ToastrService,
               private $sce: ISCEService) {
  }

  $onInit() {
    this.loadMail();
  }

  get trustedHtml(): string {
    return this.$sce.trustAsHtml(this.mail.message);
  }

  private loadMail() {
    this.errorMessage = null;
    this.loading = true;
    this.mailboxService.getMail(this.mailId)
      .then(( mail ) => {
        this.loading = false;
        this.mail = mail;
      })
      .catch(( err ) => {
        this.loading = false;
        err.data = err.data || {};
        this.errorMessage = err.data.text || 'Error';
        this.toastrService.error(this.errorMessage, 'Error');
        console.log(err);
      });
  }
}

export const MailBodyComponent: IComponentOptions = {
  controller: MailBodyCtrl,
  template: require('./mail-body.component.html'),
  bindings: {
    mailId: '<'
  }
};



// WEBPACK FOOTER //
// ./app/states/mailbox/components/mail-body/mail-body.component.ts